import script from "./tabs.vue?vue&type=script&setup=true&lang=js"
export * from "./tabs.vue?vue&type=script&setup=true&lang=js"

import "./tabs.vue?vue&type=style&index=0&id=d0df6b88&lang=scss&scoped=true"

import exportComponent from "/var/www/ddup_czb/slczb_app_web/view/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0df6b88"]])

export default __exports__